<template>
    <div>
        <public-menu></public-menu>
        <public-recharge></public-recharge>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
// import Public_recharge from "@/components/recharge/index"
import Public_recharge from "@/components/recharge/index1"
import Footer from "../../components/Footer.vue"
export default{
    components:{
        'public-menu': Public_menu,
        'public-recharge':Public_recharge,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/recharge/index.vue